<template>
    <b-pagination v-if="showPagination"
            align="right"
            v-model="val"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="team-table"
            page-class="current-page"
            next-class="next-page"
            prev-class="previous-page"
            first-number
            last-number
    >
        <template :slot="'next-text'">
            <i class="fas fa-caret-right"></i>
        </template>
        <template :slot="'prev-text'">
            <i class="fas fa-caret-left"></i>
        </template>
    </b-pagination>
</template>

<script>
    export default {
        name: 'TablePerPageSelect',
        props: {
            currentPage: Number,
            rows: Number,
            perPage: Number,
            showPagination:{
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                val: 0
            };
        },
        created() {
            this.val = this.currentPage;
        },
        updated() {
            this.sendToParent();
        },
        methods:{
            sendToParent(){
                this.$emit('method', this.val);
            }
        }
    };
</script>

<style scoped>

</style>
